<template>
  <div>
    <VoiceAgentTermsAndConditions
      v-model:visible="showVoiceAgentConsentForm"
      source="voice_agent_wrapper"
      @update:visible="handleModalVisibilityChange"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import store from "@/src/store/index.js";
import eventBus from "@/src/utils/eventBus.js";
import CallService from "@/src/api/CallService.js";
import VoiceAgentTermsAndConditions from "@/src/components/voice_agents/VoiceAgentTermsAndConditions.vue";

const showVoiceAgentConsentForm = ref(false);

const handleOpenVoiceAgentConsentForm = (data) => {
  showVoiceAgentConsentForm.value = data;
};

const handleModalVisibilityChange = (visible) => {
  if (!visible) {
    eventBus.emit("voice-agent-consent-modal-closed");
  }
};

const toCheckVoiceAgentConsent = async () => {
  try {
    const response = await CallService.checkRecordingConsent();
    if (response?.success) {
      await store.dispatch(
        "voiceAgents/setVoiceAgentConsentStatus",
        response?.voice_agent_consent,
      );
    }
  } catch (error) {
    console.error(
      "An error occurred while checking voice agent consent: ",
      error,
    );
  }
};

onMounted(() => {
  eventBus.on("open-voice-agent-consent-form", handleOpenVoiceAgentConsentForm);
  toCheckVoiceAgentConsent();
});

onUnmounted(() => {
  eventBus.off("open-voice-agent-consent-form", handleOpenVoiceAgentConsentForm);
});
</script>

